import { AppcacheManagerProvider } from "./../appcache-manager/appcache-manager";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
import { GetServiceUrl } from "../../psapp-config";
import "rxjs/add/operator/timeout";
import { Router } from "@angular/router";
import { LoginProvider } from "providers/login/login";
import { BehaviorSubject } from "rxjs";

/*
  Generated class for the RemoteServicesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RemoteServicesProvider {
    timeoutMilliseconds = 60000; // Milliseconds
    radiusDistance = 10; // Kilometers
    httpErrors = new EventEmitter<HttpErrorResponse>();
    
    constructor(
        public appcacheManagerProvider: AppcacheManagerProvider,
        public http: HttpClient,
    ) { }

    doLogin(user: string, password: string) {
        return new Promise((resolve, reject) => {
            let data = {
                UserName: user,
                Password: password
            };
            this.http
                .post(GetServiceUrl("Login"), JSON.stringify(data), {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json"
                    })
                })
                .timeout(this.timeoutMilliseconds)
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        if (err instanceof HttpErrorResponse) {
                            this.httpErrors.next(err);
                        }
                        reject(err);
                    }
                );
        });
    }
    
    doLoginToken(token: string) {
        return new Promise((resolve, reject) => {
            let data = {
                Token: token
            };
            this.http
                .post(GetServiceUrl("LoginToken"), JSON.stringify(data), {
                    headers: new HttpHeaders({
                        "Content-Type": "application/json"
                    })
                })
                .timeout(this.timeoutMilliseconds)
                .subscribe(
                    res => {
                        resolve(res);
                    },
                    err => {
                        if (err instanceof HttpErrorResponse) {
                            this.httpErrors.next(err);
                        }
                        reject(err);
                    }
                );
        });
    }

    getRanking(groupId, token) {
        return this.doRequestGet(
            GetServiceUrl("GetUserRank"),
            { idGroup: groupId },
            token
        );
    }

    getUserRankings(token) {
        return this.doRequestGet(
            GetServiceUrl("GetUserRankings"),
            null,
            token
        );
    }

    getRankingPositions(groupId, token) {
        return this.doRequestGet(
            GetServiceUrl("GetRankingPositions"),
            { groupId: groupId },
            token
        );
    }

    getTips(groupId, token) {
        return this.doRequestGet(
            GetServiceUrl("GetTips"),
            { groupId: groupId },
            token
        );
    }

    getConfig(location, token) {
        return this.doRequestGet(
            GetServiceUrl("GetConfig"),
            { latitude: location.lat, longitude: location.lng },
            token
        );
    }

    getPOSType(token) {
        return this.doRequestGet(GetServiceUrl("GetPOSType"), null, token);
    }

    getSurvey(groupId, token) {
        return this.doRequestGet(
            GetServiceUrl("GetSurvey"),
            { groupId: groupId },
            token
        );
    }

    getProducts(groupId, token) {
        return this.doRequestGet(
            GetServiceUrl("GetProducts"),
            { groupId: groupId },
            token
        );
    }

    sendPos(data, token) {
        return this.doRequestPost(
            GetServiceUrl("PostPOS"),
            {
                Id: +data.id,
                Name: data.name,
                Address: data.address,
                Latitude: data.marker.location.lat,
                Longitude: data.marker.location.lng,
                POSTypeId: data.posTypeId,
                POSCode: data.posCode,
                StateId: -1,
            },
            token
        );
    }

    sendSpot(data, token) {
        return this.doRequestPost(
            GetServiceUrl("PostSpot"),
            {
                POSId: data.POSId,
                photos: data.photos,
                SpotProducts: data.SpotProducts,
                Answers: data.Answers,
                groupId: data.groupId
            },
            token
        );
    }

    updateProfile(data, token) {
        return this.doRequestPost(
            GetServiceUrl("EditUser"),
            {
                image: data.photo
            },
            token
        );
    }

    getProfileImage(login, token) {
        return this.doRequestGet(
            GetServiceUrl("ProfileImage"),
            {
                login:login
            },
            token,
            "text"
        );
    }

    sendLoginRequest(data) {
        return this.doRequestPost(
            GetServiceUrl("PostLoginRequest"),
            data,
            null
        );
    }
    
    sendForgotPasswordRequest(data) {
        return this.doRequestPost(
            GetServiceUrl("PostForgotPasswordRequest"),
            data,
            null
        );
    }

    async getPosNearby(lat, lng, radius, groupId, token) {
        if(!lat || !lng){
            return [];
        }
        var group = Number(groupId);
        let data: any = await this.doRequestGet(
            GetServiceUrl("GetPosList"),
            { latitude: lat, longitude: lng, radius: radius, groupId: group ? group : 0 },
            token
        );

        if (data) {
            data.forEach(element => {
                element.location = {
                    lat: element.latitude,
                    lng: element.longitude
                };
            });
        }

        return data;
    }

    private async doRequestPost(url, data, token) {
        return new Promise((resolve, reject) => {

            let headers = token ? new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-type": "application/json"
            }) : new HttpHeaders({
                "Content-type": "application/json"
            });

            this.http
                .post(url, JSON.stringify(data), {
                    headers: headers
                })
                .timeout(this.timeoutMilliseconds)
                .subscribe(
                    res => {
                        if (this.appcacheManagerProvider.isAppCacheValid(url)) {
                            this.appcacheManagerProvider.saveCache(url, res);
                        }
                        resolve(res);
                    },
                    err => {
                        if (err instanceof HttpErrorResponse) {
                            this.httpErrors.next(err);
                        }
                        else{
                            if (this.appcacheManagerProvider.isAppCacheValid(url)) {
                                resolve(this.appcacheManagerProvider.restoreCache(url));
                            }
                        }
                        reject(err);
                    }
                );
        });
    }

    private async doRequestGet(url, data, token, responseType = "json") {
        let parsedUrl = data ? url + "?" + this.convertJSONtoUrlEncoded(data) : url;
        return new Promise((resolve, reject) => {
            let headers = token
                ? new HttpHeaders({
                    Authorization: "Bearer " + token
                })
                : null;

            var options;
            if(responseType == "text"){
                options = {
                    headers: headers,
                    responseType: "text"
                }
            }
            else{
                options = {
                    headers: headers
                }
            }

            this.http
                .get(parsedUrl, options)
                .timeout(this.timeoutMilliseconds)
                .subscribe(
                    res => {
                        if (this.appcacheManagerProvider.isAppCacheValid(parsedUrl)) {
                            this.appcacheManagerProvider.saveCache(parsedUrl, res);
                        }
                        resolve(res);
                    },
                    err => {
                        if (err instanceof HttpErrorResponse) {
                            this.httpErrors.next(err);
                        }
                        else{
                            if (this.appcacheManagerProvider.isAppCacheValid(parsedUrl)) {
                              resolve(this.appcacheManagerProvider.restoreCache(parsedUrl));
                            }
                        }
                        reject(err);
                    }
                );
        });
    }

    private convertJSONtoUrlEncoded(json) {
        var str = [];
        for (var key in json) {
            if (json.hasOwnProperty(key)) {
                str.push(encodeURIComponent(key) + "=" + encodeURIComponent(json[key]));
            }
        }
        return str.join("&");
    }
}
